module.exports = {
    i: '1',
    language: {
        name: 'English',
        logo: "../../../static/images/newLogo.png"
    },
    user: {
        login: '登录',
        cart: "购物车",
        Logout: "注销",
        my_order: "我的订单",
        fabrics: "面料信息",
        fashion:"款式信息",
        order: "订单管理",
        client: "我的客户",
        material: "物料物资",
        quick_order: '快速下单',
        customer_service: "客户服务",
        delivery_details: "发货查询",
        cash: "现金管理",
        ticket: "发票管理",
        contact: "联系我们",
        About: "关于我们",
        account: "账户中心",
        user_name: "用户名",
        password: "密码",
        log_in: "立即登录",
        temporary: "游客登陆",
        verify: "立即点击验证",
        successful: "验证成功",
        failed: "验证失败",
        log_out: "确定注销",
        logout_ok: "注销成功!",
        please_log: "请先登录！",
        please_verification: "请完成安全验证",
        swipe_right: "向右滑动完成验证",
        please_click: "请依次点击",
        "请选择": "请选择",
        "请输入内容": "请输入内容",
        "请输入关键词": "请输入关键词",
        "已成功加入购物车！": "已成功加入购物车！",
    },
    footer: {
        footer: "版权所有   山东尚牛智能制造有限公司",
        site: "地址：山东省桓台县耿焦路188号   ",
        phone: "电话：（0086）-400-6930-777",
        records: "建议您使用1366*768分辨率使用本系统"
    },
    home: {
        home: "首页",
        start: "自主设计",
        start_p: "自主研发设计 从这里开始",
        image: "微定制",
        image_p: "可视化操作体验 从这里开始",
    },
    verify: {
        phone: "请输入手机号",
        phoneScope: "手机号格式不正确",
        // danhao:"请输入正确的客户单号",
        danhao: "请输入客户单号",
        danhaoScope: '以2-8位字母开头,后加数字,总长度10-12位',
        fullName: "请输入姓名",
        fullNameScope: "只能输入2-5个纯中文字符或2-20个英文/字符",
        gender: '请选择性别',
        height: "请输入身高",
        heightScope: "输入范围50至250",
        weight: "请输入体重",
        weightScope: '输入范围20至350',
        measureStaff: "请输入量体师",
        img_lose: "图片加载失败",
        scope: "请输入有效尺寸范围是 ",
        leaving: "离开会使编写的内容丢失。",
        not_selected: "此操作将无法保留您选择的工艺信息！",
        continue: "是否继续？",
        determine: "确定",
        cancel: "取消",
        been_canceled: "已取消",
        delivery_address: "请输入收货地址",
        return: "返回",
        danhaoMessage: "客户单号可以使用",
        classify: "请选择分类",
        category: "请选择品类",
        style: "请选择风格",
        Fabric_type: "请选择面料类型",
        Fabric_number: "请选择面料编号",
        count: "请输入订单数量",
        orderCount: "订单数量最小为1",
        deepDesign: "请添加选择的深度设计"
    },
    start: {
        next: "下一步",
        back: "上一步",
        design: "设计",
        decoration: "深度设计",
        information: "保存信息",
        measure: "量体",
        fabric: "面料供应",
        style: "风格选择",
        category: "品类选择",
        classify: "分类",
        technologyCode:"编码",
        fabrics: "面料选择",
        craftsmanship: "款式选择",
        all: "全部",
        name: "名称",
        ingredient: "成分",
        // numberOfUnits: '可制作件数',
        numberOfUnits: '剩余面料米数',
        price: '价格',
        reset: "重置",
        input: "请输入内容",
        user_input: "客户指定框",
        essential_information: "客户基本信息",
        username: "客户姓名",
        phone: "客户手机",
        stature: "身高",
        gender: '性别',
        weight: "体重",
        surveyor: "量体师",
        order_number: "客户单号",
        receiving_address: "收货地址",
        search: '搜索',
        img: "示意图",
        data: "基本数据",
        dressing: "着装风格",
        dressingss: "身体特征",
        sizeSelection: '号型选择',
        scope: "范围",
        info: "客户信息",
        technique: "工艺信息",
        exmbroidery: "刺绣信息",
        is_info: "基本信息",
        category: "商品品类",
        address_new:"收货地址",
        type: "商品类型",
        supplier: "供应商",
        fabric: "面料名称",
        editionType: '版型',
        craft: '工艺',
        save: "保存信息",
        size: "尺寸信息",
        title: "您定制的物品已成功加入购物车",
        num: "您购物车里的商品数量是",
        preview: "商品预览",
        order_info: "订单信息",
        address: "客户地址",
        email: "客户邮箱",
        nickname: "客户昵称",
        price: "结算价格",
        $: "￥",
        others: "再看看",
        accounts: "去结算",
        enter_all: "请输入您的所有的基本数据",
        no_data: "暂无数据",
        no_3d: "暂无3D数据",
        not_selected: "其中内容未选中!请选择您喜欢的的样式。",
        not_specified: "请先输入",
        unspecified: "您还有内容未指定",
        conserveSelectCraft: "请先保存选择的工艺",
        prompt: "提示",
        this_style: "此样式在",
        check: "有冲突推荐先去查看哦！",
        style_related: "这种样式与",
        ygl: "有关联",
        related: "关联",
        conflict: "冲突",
        tjx: "同级下当前选中项",
        bei: "被",
        zhong: "中选中的",
        guanlian: "关联",
        not_choose: "无法选择！",
        loading_3D: "3D加载失败 请重试！",
        selectFabric: "请选择面料",
        "标准号型": "标准号型",
        close: "关闭",
        conserve: "保存工艺",
        content: "请输入内容",
        materialDeficiency: "面料库存不足",
        materialDeficiency2: "面料库存即将不足",
        negative: "不可以选择金额为负数的面料",
        negativeProduct: "当前产品价格为负数，请选择其它产品",
        negativeTechnology: "当前工艺价格为负数，请选择其它工艺",
        sequence: "请按分组顺序选择",
        prompt: "提示",
        confirm: "确定",
        cancel: "取消",
        selectTechnology: "已选择同类型工艺,是否替换？",
        notarize: "确认信息",
        conserve: "保存",
        waive: "放弃修改"
    },
    image: {
        new_product: "新品首发",
        new_explain: "周一周四上新，为你寻觅世间好物",
        More: "更多新品",
        popular: "人气推荐",
        designer: "设计师推荐",
        recommend: "更多推荐",
        hot: "热卖商品",
        products: "更多商品",
        everybody: "大家都在看",
        times: "购买次数",
        sales: "销量",
        cycle: "生产周期",
        category:"商品品类",
        days: "工作日",
        component: "成分",
        fabric: "面料编号",
        style: "款式号",
        customized: "面料选择",
        tailor: "个性定制",
        measure: "进入量体",
        homologous: "同系热品",
        details: "详情",
        commodity: "商品风格",
        whole: "全部",
        price: "价格",
        floor: "最低价格",
        ceiling: "最高价格",
        search: "搜索",
        keywords: "请输入关键字",
        peakPriceMessage: "请输入最高价格",
        bottomPriceMessage: "请输入最低价格"
    },
    measure: {
        self: "自主量体",
        Refer: "参照视频",
        selected: "自主选择",
        standard: "标准号型",
        "cm": "cm",
        "kg": "kg"
    },
    cart: {
        order: "订单号",
        keywords: "请输入关键字如",
        not_submitted: "未预提交",
        audit: "已预提交",
        failure: "审核失败",
        picture: "商品图片",
        date: "添加日期",
        number: "数量",
        price: "价格",
        emergency: "是否加急",
        GW_address:"收货地址",
        status: "订单状态",
        operation: "操作",
        again: "再次购买",
        edit: "编辑",
        submission: "预提交",
        delete: "删除订单",
        export: "导出列表",
        export_order: "导出订单",
        total: "商品总数",
        total_price: "总价",
        pay: "去付款",
        confirm: "确定",
        payment: "请选择付款方式",
        balance: "余额支付",
        available: '可用余额',
        payment_type: "'自主设计订单'和'微定制订单'不能同时付款，请检查所选订单",
        statu: "选择的订单在存在审核失败或者未预提交的数据",
        select: "请选择一条订单",
        delete_order: "请选择您要删除的订单",
        export_details: "请选择您要导出详情的订单",
        successful: "支付成功",
        processing: "正在处理",
        need_pay: "需 支 付",
        balance: "余额",
        alipay: "支付宝",
        WeChat: "微信",
        account_balance: "账 户 余 额",
        confirm_payment: "确 定 支 付",
        please_alipay: "请 用 支 付 宝 扫 描 二 维 码 ",
        scanning_phone: "扫描成功 请在手机上进行操作",
        Please_WeChat: " 请 用 微 信 扫 描 二 维 码 ",
        withdraw_balance: "提取余额",
        actual_name: "真 实 姓 名",
        please_name: "请输入真实姓名",
        select_payment: "请选择支付方式",
        buyNum: "购买数不得小于 1",
        maxNum: "最大数量不能大于一万",
        pdStaues: "未预提交的不能付款",
        orders: "不能支付多个订单",
        adresseeInfo: "请选择收货地址",
        negative: "不能支付价格为零或负数的订单"
    },
    fabrics: {
        status: "面料状态",
        no_deactivated: "未停用",
        deactivated: "已停用",
        serial: "序号",
        number: "面料号",
        series: "图片",
        attribute: "属性",
        decor: "花色",
        colour: "颜色",
        gauze: "纱支",
        stop: "是否停用"
    },
    material: {
        price: "单价",
        details: "订单详情",
        quantity: "购买数量",
        inventory: "库存",
        jian: "件",
        buy: "立即购买",
        material_search: "请输入物料名进行搜索",
        add_cart: "加入购物车"
    },
    myClient: {
        add_info: "添加客户信息",
        number: "序号",
        customer: "客户名",
        nickname: "客户昵称",
        height: "身高",
        weight: "体重",
        phone: "电话",
        mailbox: "邮箱",
        operating: "操作",
        edit: "编辑",
        delete: "删除",
        info: '客户信息',
        customer_number: "客户单号",
        area: "地区",
        detailed_area: "详细地区",
        remarks: "备注",
        determine: "确定",
        gender: '客户性别',
        fullNameMessage: "请填写客户名",
        nickNameMessage: "请填写客户昵称",
        genderMessage: "请填写性别",
        addressMessage: "请填写地址信息",
        heightMessage: "请填写身高",
        weightMessage: "请填写体重",
        phoneMessage: "请填写手机号",
        phoneVerifyMessage: "手机号格式不正确"
    },
    order: {
        recharge_method: "充 值 方 式 ",
        courier_information: "快递信息",
        want_amount: "请输入您要体现的金额",
        withdrawal_amount: "提 现 金 额 ",
        enter_account: "请输入要体现到的账户",
        account: "提 现 账 户",
        withdrawal_method: "提 现 方 式 ",
        client_name: "客户公司名称",
        account_name: "账户名",
        transaction_item: "交易项目",
        transaction_date: "交易日期",
        expenditure: "支出",
        income: "收入",
        statement: "对账单",
        recharge: "充值",
        please_amount: "请输入充值金额",
        current_balance: "当前账户余额",
        please: "请输入订单号/客户单号/交易项目名称/备注",
        order_details: "订单详情",
        express_delivery: "快递",
        tracking_number: "快递单号",
        courier_company: "快递公司",
        delivery_date: "发货时间",
        logistics_number: "订单号",
        shipping_settings: "发货设置",
        add_delivery_address: "新增收货地址",
        under_review: "审核中",
        time: "下单时间",
        end: "结束时间",
        start: '开始时间',
        // transaction: "交易时间",
        transaction: "交货时间",
        daizhifu:"待支付",
        daishenhe:"待审核",
        daishengchan:"待生产",
        all: "全部",
        made: "已制版",
        unpay:"待支付",
        production: "生产中",
        apply: "申请发货",
        shipped: "已发货",
        cancel: "撤单",
        export_list: "导出列表",
        export_details: "导出详情",
        number: "序号",
        single_num: "单号",
        name: "客户名",
        accountName: '账号名',
        material: '面料号',
        order_date: "下单日期",
        delivery_date2: "预计交货时间",
        delivery: "发货时间",
        amount: "订单金额",
        num: "数量",
        order_status: "订单状态",
        operating: "操作",
        buy_again: "再次购买",
        batch: "批量申请发货",
        paid: "已支付",
        push: "推送失败",
        info: '客户信息',
        is_info: "基本信息",
        order_number: "客户单号",
        username: "客户姓名",
        phone: "客户号码",
        address: "客户地址",
        email: "客户邮箱",
        nickname: "客户昵称",
        category: "商品品类",
        type: "商品类型",
        supplier: "供应商",
        fabric: "面料名称",
        size: "尺寸信息",
        formula: "价格公式",
        technique: "工艺信息",
        exmbroidery: "刺绣信息",
        choose_date: "选择日期时间",
        select_address: "选择地址",
        add_address: "添加新地址",
        set_Default: "设为默认",
        edit: "编辑",
        delete: "删除",
        include_order: "包含订单",
        add_order: "添加订单",
        chosen: "已选择",
        orders: "条订单",
        receiver: "收货人",
        address: "详细地址",
        contact: "联系方式",
        back_list: "返回列表",
        delivery_success: "申请发货成功",
        picture: "商品图片",
        fabric: "面料",
        confirm: "确认",
        fail: "失败原因"
    },
    quick: {
        product_info: "产品信息",
        gender: "性别",
        category: "品类",
        style: "风格",
        pattern: "版型",
        mailyardTechnology:"工艺",
        fabric_type: "面料类型",
        fabric: "面料编号",
        order_number: "客户单号",
        quantity_order: "订单数量",
        technique: "工艺信息",
        info: "客户信息",
        phone: "客户手机",
        username: "客户姓名",
        height: "身高",
        weight: "体重",
        surveyor: "量体师",
        self: "自主量体",
        Refer: "参照视频",
        selected: "自主选择",
        standard: "标准号型",
        data: "基本数据",
        scope: "范围",
        dress_style: "着衣风格",
        schematic: "量体示意图",
        size_selection: "号型选择",
        add_cart: "加入购物车",
        client: "我的客户",
        design: "深度设计",
        selectInfo: "选取我的客户信息",
        craftCode: "请选择工艺"
    },
    invoice: {
        order_number: "订单号/客户订单号",
        return: "返回",
        consequences: "如我司未按国家相关规定申请开具或使用增值税专用发票，由我司自行承担相应法律后果。",
        know: "我已充分了解上述各项相关国家税法和发票管理规定，并确认仅就我司实际购买商品或服务索取发票。",
        require2: "（2）虽有货物采购或者接受应税劳务但要求他人为自己开具数量或金额与实际情况不符的增值税专用发票】，否则属于“虚开增值税专用发票”。",
        require1: "（1）在没有货物采购或者没有接受应税劳务的情况下要求他人为自己开具增值税专用发票;",
        require: "根据国家税法及发票管理相关规定，任何单位和个人不得要求他人为自己开具与实际经营业务情况不符的增值税专用发票【包括并不限于",
        VAT: "申请开具增值税专用发票确认书",
        authorization: "增票授权委托书模板下载",
        upload_attorney: "上传增票授权委托书",
        click_upload: "点击上传",
        notice: "上传文件均需加盖公章，支持的图片格式为jpg/jpeg/png,务必上传清晰照片，单个图片需小于10M。若上传按钮显示有问题，请安装Flash插件。",
        upload_files: "上传资质文件",
        cancel: "取消",
        determine: "确定",
        confirmation_qualification: "《增票资质确认书》",
        read_agree: "我已阅读并同意",
        all_required: "(所有信息均为必填)",
        fill_info: "填写增票资质信息",
        attorney_increase: "增票授权委托书",
        taxpayer_certificate: "一般纳税人证书",
        registration_copy: "税务登记证副本",
        bank_account: "银行账户",
        bank_deposit: "开户银行",
        register_phone: "注册电话",
        registered_address: "注册地址",
        taxpaye_code: "纳税人识别码",
        company_name: "单位名称",
        increase_info: "增票资质信息",
        delete: "删除",
        modify: "修改",
        complement_invoicing: "补开发票",
        ticket_qualification: "增票资质",
        shipping_address: "收货地址",
        qualification_increase: "您的增票资质",
        not_added: "未添加",
        add: "添加增票资质",
        amount_goods: "商品金额",
        "发票状态": "发票状态",
        "操作": "操作",
        "开具发票": "开具发票",
        "发票类型": "发 票 类 型",
        "普通发票": "普通发票",
        "增值税发票": "增值税发票",
        "发票名称": "发 票 名 称",
        "纳税人识别号": "纳税人识别号",
        "注册地址": "注 册 地 址",
        "注册电话": "注 册 电 话",
        "银行账户": "银 行 账 户",
        "开户银行": "开 户 银 行",
        "所需价格": "所 需 价 格",
        "收货地址": "收 货 地 址",
        "收货人": "收货人",
        "所在地区": "所在地区",
        "地址": "地址",
        "手机": "手机",
        "固定电话": "固定电话",
        "邮箱": "邮箱",
        "确认并提交": "确 认 并 提 交",
        "请输入订单号/客户单号/面料号/客户姓名等关键字": "请输入订单号/客户单号/面料号/客户姓名等关键字",
        "请填写名称": "请填写名称",
        "纳税人识别号位数限制为15到20位": "纳税人识别号位数限制为15到20位",
        "注册地址必须包含汉字": "注册地址必须包含汉字",
        "电话格式不正确": "电话格式不正确",
        "开户银行必须包含汉字": "开户银行必须包含汉字",
        "银行账号只能是数字": "银行账号只能是数字",
        "提交成功": "提交成功",
        "您未具有开具增值税发票的资质": "您未具有开具增值税发票的资质",
        "已支付": "已支付",
        "已制版": "已制版",
        "生产中": "生产中",
        "已发货": "已发货",
        "撤单": "撤单",
        "待审核": "待审核",
        "未申请": "未申请",
        "已申请": "已申请",
        "审核驳回": "审核驳回",
        "审核通过": "审核通过",
        "请选择发票类型": "请选择发票类型",
        "下一步": "下一步",
        "上一步": "上一步",
        "请确认商品价格以及收货地址": "请确认商品价格以及收货地址",
        "价格": "价格",
        "名称": "名称",
        "必填": "必填",
        "纳税人识别码": "纳税人识别码",
        "新增收货地址": "新增收货地址",
        "您已创建": "您已创建",
        "个收货地址,最多可创建": "个收货地址,最多可创建",
        "个": "个",
        "默认地址": "默认地址",
        "设为默认": "设为默认",
        "编辑": "编辑",
        "最多添加20个发票地址": "最多添加20个发票地址",
        "添加收货地址": "添加收货地址",
        "详细地址": "详细地址",
        "手机号码": "手机号码",
        "或": "或",
        "或固定电话": "固定电话",
        "地址别名": "地址别名",
        "建议填写常用名称": "建议填写常用名称",
        "家里": "家里",
        "父母家": "父母家",
        "公司": "公司",
        "保存收货地址": "保存收货地址",
        consigneeMessage: '收货人不能为空',
        areaMessage: '所在地区的省市区不能为空',
        addressMessage: '详细地址不能为空',
        phoneMessage: '手机号不能为空',  
    }
}



// WEBPACK FOOTER //
// ./src/components/language/zh.js